import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const comunicaciones = {
	state: {
		comunicaciones: ''
	},
	getters: {
		getComunicaciones: state => state.comunicaciones,
	},
	actions: {
		requestComunicaciones: function ({ commit, dispatch }, type) {
			if (type == null) {
				return
			}
			return new Promise((resolve, reject) => {
				axios.get(`/api/${type}/dameComunicaciones`).then(response => {
					if (response.data.status == 0) {
						commit('setComunicaciones', response.data.datos)
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});

		}
	},
	mutations: {
		setComunicaciones: function (state, data) {
			state.comunicaciones = data;
		}
	}
}

export default comunicaciones;



// WEBPACK FOOTER //
// ./src/store/comunicaciones.js